'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Button } from '@/components/ui/button';
interface CricketQuestionProps {
  options: string[];
}
const pollOptions = ['ஹாரி புரக்', 'ஐடன் மார்கரம்', 'ராகுல் திரிபாதி'];
const CricketQuestion = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="text-center mb-6"><p className="text-18-tamil-700 pb-8 text-1B1B1B leading-[1.5]  line-clamp-3">TATA IPL 2023 இல் சன்னரசர்ஸ் வெற்றிராபாத் அதிக ரன் எடுத்தவர் யார்?</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-ECEEF3 py-8 px-4 max-w-md mx-auto border-DCDCDC border-1">{t0}<div className="space-y-3">{pollOptions.map(_temp)}</div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default CricketQuestion;
function _temp(option, index) {
  return <Button variant="darkblue" key={index} className="w-full py-3 px-4 border-012061 border-1 text-16-tamil-600 text-FFFFFF rounded-sm text-center line-clamp-1 hover:bg-blue-700 transition-colors">{option}</Button>;
}